/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { PermissionType } from '../models/PermissionType';

export class PermissionGrant {
  'permission': PermissionType;
  /**
  * If present, the ID of the set of access conditions that restrict the resources the permission is granted for. The ID must be present in an entry in `accessConditions`, and the permission itself must support access conditions. If omitted, the permission is granted for all resources. 
  */
  'accessConditionId'?: string;
  /**
  * An optional list of scopes that further restrict the permission grant when a data access rule is applied.
  */
  'conditionalScopes'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "permission",
      "baseName": "permission",
      "type": "PermissionType",
      "format": ""
    },
    {
      "name": "accessConditionId",
      "baseName": "accessConditionId",
      "type": "string",
      "format": ""
    },
    {
      "name": "conditionalScopes",
      "baseName": "conditionalScopes",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PermissionGrant.attributeTypeMap;
  }

  public constructor() {
  }
}



